export default function CompanyOverview() {
  return (
    <section id="overview" className="px-4 py-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">事業案内</h2>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="flex items-center mb-4">
            <div className="w-12 h-12 flex items-center justify-center bg-primary rounded-full mr-4">
              <i className="ri-building-line text-white text-lg"></i>
            </div>
            <div>
              <h3 className="font-bold text-green-900">株式会社 SunAce</h3>
              <p className="text-sm text-green-600">代表取締役 小島潤三郎</p>
            </div>
          </div>
          <div className="space-y-3 text-sm">
            <div className="flex">
              <span className="w-20 text-green-600">設立日</span>
              <span className="text-green-900">令和 1 年 10 月 7 日</span>
            </div>
            <div className="flex">
              <span className="w-20 text-green-600">資本金</span>
              <span className="text-green-900">100 万円</span>
            </div>
            <div className="flex">
              <span className="w-20 text-green-600">従業員数</span>
              <span className="text-green-900">7名</span>
            </div>
          </div>
        </div>
        <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white mb-6">
          <h3 className="font-bold mb-3 text-green-100">取引先企業</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 text-sm text-green-100">
            <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-2">
              <i className="ri-building-2-line mr-2"></i>
              <span>栗原工業株式会社</span>
            </div>
            <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-2">
              <i className="ri-building-2-line mr-2"></i>
              <span>三和電気土木工事株式会社</span>
            </div>
            <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-2">
              <i className="ri-building-2-line mr-2"></i>
              <span>三浦電気株式会社</span>
            </div>
            <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-2">
              <i className="ri-building-2-line mr-2"></i>
              <span>株式会社扇港電機</span>
            </div>
            <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-2">
              <i className="ri-building-2-line mr-2"></i>
              <span>松電株式会社</span>
            </div>
            <div className="flex items-center bg-white bg-opacity-10 rounded-lg px-3 py-2">
              <i className="ri-building-2-line mr-2"></i>
              <span>株式会社エルシア</span>
            </div>
          </div>
          <p className="text-xs text-green-100 mt-3 text-center opacity-80">など</p>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <h3 className="font-bold text-green-900 mb-4">アクセス</h3>
          <div className="space-y-4 text-sm">
            <div>
              <p className="font-medium text-green-900 mb-1">所在地</p>
              <p className="text-green-600">〒444-0215<br />愛知県岡崎市中村町字屋敷 60-1</p>
            </div>
            <div>
              <p className="font-medium text-green-900 mb-1">土場住所</p>
              <p className="text-green-600">〒444-0215<br />愛知県岡崎市中村町字殿海道 14 番 1</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
